export default __webpack_public_path__ + "static/media/home_card.a4d10c99.png";